module.exports = __webpack_public_path__ + "static/img/license.ba39b07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/license.png
// module id = rO82
// module chunks = 1